
<template>
  <div class="">
    <div class="filter-wrapper overflow-hidden pt-1">
      <CategoryFilter v-if="!$store.state.showGoogleMap" :filter-causes="filterCauses" />
    </div>
    <div class="dashboard-post-item" v-if="posts.length">
      <swiper ref="mySwiper" :options="swiperOptions" class="">
        <swiper-slide v-for="(item, index) in posts" :key="index" class="">
          <article class="post-item" @click="
            () => {
              showCauseSingle(
                item,
                postType === 'partner' ? 'partnerSingle' : 'causeSingle'
              );
            }
          ">
            <div class="cause-item__slide post-item-image relative w-full">
              <img loading="lazy" class="absolute top-0 left-0 object-center object-cover h-full w-full"
                :src="getNposImage(getNposJson(item.img)[0])" />
            </div>
            <div class="item-content my-3">
              <h4 class="item-title text-14 font-bold">
                {{ getNposJson(item.title)["en"] || "" }}
              </h4>
              <h4 class="text-14 text-black text-content">
                {{ item.tags ? tagName(item.tags.name) : "" }}
              </h4>
            </div>

            <button class="border p-1 flex btn-discount justify-center" v-if="item.max_discount > 0">
              <img class="mx-1 mt-1" :srcset="`${savePic}, ${savePic}`" :src="`${savePic}`" alt="Discount Tag"
                width="auto" height="auto" />
              <span class="px-2 text-12">Save {{ item.max_discount }}% Off</span>
            </button>
          </article>
        </swiper-slide>
      </swiper>
    </div>
    <div v-if="!posts.length && filterCategory.length" class="text-center text-text font-bold my-3">
      This category has no listing
    </div>
  </div>
</template>

<script>
import CategoryFilter from "../Filters/TagFilter.vue";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import mixins from "../../config/mixins";
export default {
  name: "PostBlog_new",
  mixins: [mixins.npos, mixins.retailers],
  components: {
    CategoryFilter,
    Swiper,
    SwiperSlide
  },
  props: ["postType"],
  mounted() {
    if (this.$getState('primaryLatlng')) {
      this.getPosts()
    }
  },
  data: function () {
    return {
      posts: [],
      locale: this.$i18n.locale,
      filterCategory: [],
      postSingle: {},
      page: 0,
      limit: 100,
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination"
        },
        spaceBetween: 20,
        slidesPerView: 1.5
      }
    };
  },
  computed: {
    savePic() {
      return `${this.$store.state.appUrl}/img/pwa/dashboard-icons/tag.svg`
    },
    showSection() {
      if (!this.posts.length && !this.filterCategory.length) return false
      return true
    }
  },
  methods: {
    tagName: function (jsonStr) {
      if (!jsonStr) return
      const obj = JSON.parse(jsonStr)
      return obj[this.locale] || obj["en"] || ''
    },
    clearPosts: function () {
      this.page = 0;
      this.posts = [];
    },
    getPostsArguments: function () {
      const args = {
        offset: this.page * this.limit,
        search: '',
        tag: '',
        category: this.filterCategory,
        sort_by: '',
        limit: this.limit
      }
      return args;
    },

    showCauseSingle: function (item, type) {
      this.postSingle = item;
      this.$setState('saveSingleCause', item)
      this.$setState("typeAppFilter", type);
      this.$setState("showAppFilters", true);
      this.$setState("isNavigation", false);
    },
    filterCauses: function (id) {
      this.filterCategory = []
      id && this.filterCategory.push(id)
      this.clearPosts();
      this.getPosts();
    },
    getPosts: async function () {
      this.postLoad = true;
      const args = this.getPostsArguments();
      await this.retailersInFiftyMiles(args, this.setSection)
    },
    setSection: function (data) {
      this.posts = data
      this.$store.commit('setPostsFlag', this.showSection)
    }
  },
  watch: {
    "$store.state.primaryLatlng": function () {
      this.getPosts()
    },
    "$store.state.userLocation": function () {
      this.$getState('primaryLatlng') || this.getPosts()
    }
  },
};
</script>